import { useMutation } from "@tanstack/react-query";
import { deactivateLeat } from "../../api/bLeatApi";

export const useDeactivateLeat = () => {
  return useMutation({
    mutationKey: ["deactivate-leat"],
    mutationFn: (data) => deactivateLeat(data),
    onError: (error) => {
      console.error("Leat deactivation error:", error.response || error);
    },
  });
};
